import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function FirstApprovedOfferBetween({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getFirstApprovedOfferBetween(query);
  const value =
    options.find((option) => !areObjectsDifferent(state, option.value)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) =>
        setQuery(setFirstApprovedOfferBetween(option.value))
      }
      stringify={(option) => option.label}
      value={value}
      label="Approved since"
      description="Filter by how long since the first lender approved the application"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  {
    label: 'All',
    value: undefined,
  },
  {
    label: '1-7 days',
    value: {
      To: days(-1),
      ToEndOfDay: true,
      From: days(-7),
      FromStartOfDay: true,
    },
  },
  {
    label: '8-15 days',
    value: {
      To: days(-8),
      ToEndOfDay: true,
      From: days(-15),
      FromStartOfDay: true,
    },
  },
  {
    label: '16-45 days',
    value: {
      To: days(-16),
      ToEndOfDay: true,
      From: days(-45),
      FromStartOfDay: true,
    },
  },
];

function days(days: number) {
  return days * 24 * 60;
}

function setFirstApprovedOfferBetween(
  offset: Value
): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryFirstApprovedOfferAtOffset: offset,
  });
}

function getFirstApprovedOfferBetween(query: ace_index.FindInput) {
  return query.SummaryFirstApprovedOfferAtOffset;
}

type Value = ace_index.FindInput['SummaryFirstApprovedOfferAtOffset'];
